import { api } from '../index.js'

const pageSize = 20

export default {
  namespaced: true,

  state: {
    mailQueues: [],
    mailQueuesPage: 0,
    mailQueuesPageSize: pageSize,
    mailQueuesTotalPages: 0
  },

  mutations: {
    updateMailQueues(state, value) {
      state.mailQueues = value
    },

    updateMailQueuesPage(state, value) {
      state.mailQueuesPage = value
    },

    updateMailQueuesTotalPages(state, value) {
      state.mailQueuesTotalPages = value
    }
  },

  actions: {
    async fetchAll({ commit, state }, { id, page }) {
      page = parseInt(page, 10) || 1
      commit('updateMailQueuesPage', page)

      let [queues, res] = await api.mail_queues.all(id, page)
      commit('updateMailQueues', queues)

      if (res.headers.has('X-Pagination-Total-Pages')) {
        commit('updateMailQueuesTotalPages', parseInt(res.headers.get('X-Pagination-Total-Pages'), 10))
      }
    }
  }
}
